import { createRouter, createWebHistory } from "vue-router";
import { useStore } from "@/store";
import { normalizeRouteParam } from "@/utils";

const routes = [
  {
    path: "/login",
    name: "home",
    redirect: (to) => {
      const store = useStore();
      const userId = store.getUserId;
      const testPlanId = normalizeRouteParam(store.getTestPlanId);
      if (userId) {
        return "/test";
      } else {
        return `/login/${testPlanId}`;
      }
    },
  },
  {
    path: "/login/:encodeTestPlanId",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/index.vue"),
  },
  {
    path: "/instLogin/:encodeInstId?",
    name: "instLogin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/instLogin/index.vue"),
  },
  {
    path: "/personBoard",
    name: "personBoard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/personBoard/index.vue"),
  },
  {
    path: "/planBoard",
    name: "planBoard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/planBoard/index.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/test/index.vue"),
  },
  {
    path: "/report/:answerUserId",
    name: "report",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/report/index.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const userId = sessionStorage.getItem("userId");
//   const testPlanId = sessionStorage.getItem("testPlanId");
//   if (!userId && !to.path.includes("/login")) {
//     next(`/login/${testPlanId}`);
//   } else {
//     next();
//   }
// });

// router.afterEach((to, from, next) => {
//   console.log(to.path, from.path);
//   // 在A问卷界面，跳转到B问卷，再后退，虽然当前页面的sessionStorage打印出来是A问卷的信息，但开发者工具里显示的是B问卷的信息
//   // 开始答题以后在新的url里，再次打印就变成B问卷的信息，会使作答者以为自己在做A问卷，实际在做B问卷，在系统里录入的也是B问卷
//   if (to.path.includes("/login/")) {
//     sessionStorage.clear();
//   }
// });

export default router;
